export const lawCase = {
  id: undefined,
  number: '',
  law_status_id: '',
  applicant_id: '',
  defendant_id: '',
  start_date: '',
  end_date: '',
  costs: null,
  law_info: '',
  law_case_stages: [],
  object_resources: []
}

export const lawCaseStage = {
  name: '',
  start_date: '',
  end_date: '',
  description: '',
  result: ''
}
